export default __webpack_public_path__ + "static/media/cityEn.2e2c8a53.png";